import { render } from "./UserPortalSettingsManager.vue?vue&type=template&id=7fbbd396&scoped=true"
import script from "./UserPortalSettingsManager.vue?vue&type=script&lang=js"
export * from "./UserPortalSettingsManager.vue?vue&type=script&lang=js"

import "./UserPortalSettingsManager.vue?vue&type=style&index=0&id=7fbbd396&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbbd396"]])

export default __exports__